<template>
  <div class="position-relative">
    <div
      v-if="headerCoverImage"
      class="page__header-cover position-absolute w-100 h-100 z-[-1]"
      :class="{ 'opacity-25': enableCoverTransparency }"
    >
      <strapi-image
        class="page__header-cover__img w-100 h-auto"
        :class="{
          'max-w-full mask-image-gradient-top': enableCoverTransparency,
        }"
        :lazy="false"
        auto-scale
        :alt-fallback="
          name == null || name.length === 0
            ? 'Background'
            : `${name} Background`
        "
        :image="headerCoverImage"
      />
    </div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { StrapiImage } from '~/apollo/types/types';

export default defineComponent({
  props: {
    headerCoverImage: {
      type: Object as PropType<StrapiImage>,
      required: true,
    },
    name: {
      type: String,
      default: '',
    },
    enableCoverTransparency: {
      type: Boolean,
      default: true,
    },
  },
});
</script>
